export class CareerMapService {
  baseUrl: string;

  constructor({ baseUrl }: { baseUrl: string }) {
    this.baseUrl = baseUrl;
  }

  async getGraph(
    id?: string,
    similarityThreshold: number = 0.3
  ): Promise<Response> {
    var url = `${this.baseUrl}api/v1/Graph`;
    if (id) {
      url += `/${id}`;
    }
    return await fetch(`${url}?similarityThreshold=${similarityThreshold}`, {
      method: 'GET',
      headers: new Headers({
        Accept: 'application/json'
      })
    });
  }

  async getCareerRoles(): Promise<Response> {
    return await fetch(`${this.baseUrl}api/v1/Graph/CareerRoles`, {
      method: 'GET',
      headers: new Headers({
        Accept: 'application/json'
      })
    });
  }

  async getCareerRoleDetail(id: string): Promise<Response> {
    return await fetch(`${this.baseUrl}api/v1/Graph/CareerRoles/${id}`, {
      method: 'GET',
      headers: new Headers({
        Accept: 'application/json'
      })
    });
  }
}
